export default __webpack_public_path__ + "static/media/71.7afd1e8c.png";